/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_myteam_signin_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep your line-up race to race and see your points and price changes after every Grand Prix — saved on this device.`)
};

const es_f1_myteam_signin_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantén tu alineación carrera a carrera y ve tus puntos y cambios de precio después de cada Gran Premio — guardado en este dispositivo.`)
};

const de_f1_myteam_signin_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Behalte dein Line-up von Rennen zu Rennen und sieh nach jedem Grand Prix deine Punkte und Preisänderungen — gespeichert auf diesem Gerät.`)
};

const nl_f1_myteam_signin_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Behoud je opstelling race na race en bekijk je punten en prijsveranderingen na elke Grand Prix — opgeslagen op dit apparaat.`)
};

const fr_f1_myteam_signin_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conservez votre composition course après course et consultez vos points et variations de prix après chaque Grand Prix — sauvegardé sur cet appareil.`)
};

const it_f1_myteam_signin_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantieni la tua formazione gara dopo gara e guarda punti e variazioni di prezzo dopo ogni Gran Premio — salvato su questo dispositivo.`)
};

const pt_br2_f1_myteam_signin_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantenha sua escalação corrida a corrida e veja seus pontos e mudanças de preço após cada Grande Prêmio — salvo neste dispositivo.`)
};

const pt_f1_myteam_signin_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantém o teu alinhamento corrida a corrida e vê os teus pontos e alterações de preço após cada Grande Prémio — guardado neste dispositivo.`)
};

const ja_f1_myteam_signin_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レースごとにラインアップを引き継ぎ、各グランプリ後にポイントと価格変動を確認できます — このデバイスに保存されます。`)
};

const zh_f1_myteam_signin_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`让阵容逐场延续，每站大奖赛后查看你的得分和价格变动 — 保存在此设备上。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_myteam_signin_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_myteam_signin_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_myteam_signin_desc", locale)
	if (locale === "en") return en_f1_myteam_signin_desc(inputs)
	if (locale === "es") return es_f1_myteam_signin_desc(inputs)
	if (locale === "de") return de_f1_myteam_signin_desc(inputs)
	if (locale === "nl") return nl_f1_myteam_signin_desc(inputs)
	if (locale === "fr") return fr_f1_myteam_signin_desc(inputs)
	if (locale === "it") return it_f1_myteam_signin_desc(inputs)
	if (locale === "pt-BR") return pt_br2_f1_myteam_signin_desc(inputs)
	if (locale === "pt") return pt_f1_myteam_signin_desc(inputs)
	if (locale === "ja") return ja_f1_myteam_signin_desc(inputs)
	return zh_f1_myteam_signin_desc(inputs)
};